// eslint-disable-next-line no-unused-vars
import slick from "slick-carousel";

export default {
  init() {
    $(".slider").slick({
      prevArrow: ".arrow-left",
      nextArrow: ".arrow-right",
      dots: true,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 3000,
      //pauseOnHover: true,
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js